/**
 * Created by cuiguixiang 2018-05-03
 * 大图查看缩放滑动切换
 */
var PhotoSwipe = require('./photoswipe.min.js');
var PhotoSwipeUI_Default = require('./photoswipe-ui-default.min.js');

// 校验是否为触屏环境
var isTouch = !!(
  'ontouchstart' in window ||
  (window.DocumentTouch && document instanceof window.DocumentTouch)
)

var isIE8 = /msie 8\.0/i.test(window.navigator.userAgent.toLowerCase());

var defaultoptions = {
  maxSpreadZoom: 3.5,
  tapToClose: 0,
  getDoubleTapZoom: function () {
    return 2;
  },
  errorMsg: '<div class="pswp__error-msg">图片加载失败</div>',
  enableOriImg: true, // 是否开启查看原图
};

var hdfgallery = {
  /*手动调用*/
  show: function (items, options = {}) {
    if (items.length == 0) {
      return;
    }
    this._addgallerydom();
    var galleryv = document.getElementsByClassName('pswp')[0];

    for (var i = 0; i < items.length; i++) {
      items[i].w = window.innerWidth;
      items[i].h = window.innerHeight;
    }

    // if(options && typeof options =="object"){
    options = this._deepCopy(options, defaultoptions);
    // }
    var gallery = new PhotoSwipe(
      galleryv,
      PhotoSwipeUI_Default,
      items,
      options
    );
    gallery.init();
  },

  /*默认加载，点击自动弹出查看大图*/
  initdefault: function (galleryContainer, options) {
    //合并 调用者传入参数
    if (options && typeof options == 'object') {
      defaultoptions = this._deepCopy(options, defaultoptions);
    }

    this._initPhotoSwipeFromDOM(galleryContainer);
  },
  _initPhotoSwipeFromDOM: function (gallerySelector) {
    var galleryElements = document.querySelectorAll(gallerySelector);

    for (var i = 0, l = galleryElements.length; i < l; i++) {
      galleryElements[i].setAttribute('data-pswp-uid', i + 1);
      galleryElements[i].onclick = this._onThumbnailsClick(this);
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = this._photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
      this._openPhotoSwipe(
        hashData.pid,
        galleryElements[hashData.gid - 1],
        true,
        true
      );
    }
  },

  /*根据节点中src，href组装成最终大图数组*/
  _parseThumbnailElements: function (el) {
    var thumbElements = el.childNodes,
      numNodes = thumbElements.length,
      items = [],
      figureEl,
      linkEl,
      size,
      item;

    for (var i = 0; i < numNodes; i++) {
      figureEl = thumbElements[i];
      if (figureEl.nodeType !== 1) {
        continue;
      }

      // linkEl = figureEl.children[0];
      linkEl = figureEl; //
      // size = linkEl.getAttribute('data-size').split('x');
      //读取节点中大小，实际不使用该大小
      item = {
        src: linkEl.getAttribute('href'),
        bsrc: linkEl.querySelector('img').getAttribute('data-bsrc'),
        w: window.innerWidth,
        h: window.innerHeight,
      };

      if (figureEl.children.length > 1) {
        // <figcaption> content
        item.title = figureEl.children[1].innerHTML;
      }

      if (linkEl.children.length > 0) {
        // <img> thumbnail element, retrieving thumbnail url
        item.msrc = linkEl.children[0].getAttribute('src');
      }

      item.el = figureEl; // save link to element for getThumbBoundsFn
      items.push(item);
    }

    return items;
  },

  //点击事件
  _onThumbnailsClick: function (self) {
    return function (e) {
      /*寻找指定类型父节点*/
      var closest = function (el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
      };

      e = e || window.event;
      e.preventDefault ? e.preventDefault() : (e.returnValue = false);

      var eTarget = e.target || e.srcElement;

      // find root element of slide
      var clickedListItem = closest(eTarget, function (el) {
        return el.tagName && el.tagName.toUpperCase() === 'A';
      });

      if (!clickedListItem) {
        return;
      }

      // find index of clicked item by looping through all child nodes
      // alternatively, you may define index via data- attribute
      var clickedGallery = clickedListItem.parentNode,
        childNodes = clickedListItem.parentNode.childNodes,
        numChildNodes = childNodes.length,
        nodeIndex = 0,
        index;

      for (var i = 0; i < numChildNodes; i++) {
        if (childNodes[i].nodeType !== 1) {
          continue;
        }

        if (childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }
        nodeIndex++;
      }

      if (index >= 0) {
        self._openPhotoSwipe(index, clickedGallery);
      }
      return false;
    };
  },

  // 解析当前url地址中是否是该图片id，是则默认打开大图 (#&pid=1&gid=2)
  _photoswipeParseHash: function () {
    var hash = window.location.hash.substring(1),
      params = {};

    if (hash.length < 5) {
      return params;
    }

    var vars = hash.split('&');
    for (var i = 0; i < vars.length; i++) {
      if (!vars[i]) {
        continue;
      }
      var pair = vars[i].split('=');
      if (pair.length < 2) {
        continue;
      }
      params[pair[0]] = pair[1];
    }

    if (params.gid) {
      params.gid = parseInt(params.gid, 10);
    }

    return params;
  },

  _openPhotoSwipe: function (index, galleryElement, disableAnimation, fromURL) {
    this._addgallerydom();

    var pswpElement = document.querySelectorAll('.pswp')[0],
      gallery,
      options,
      items;

    items = this._parseThumbnailElements(galleryElement);

    options = {
      galleryUID: galleryElement.getAttribute('data-pswp-uid'),
      getThumbBoundsFn: function (index) {
        var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
          pageYScroll =
            window.pageYOffset || document.documentElement.scrollTop,
          rect = thumbnail.getBoundingClientRect();

        pageYScroll -=
          ((window.innerHeight / window.innerWidth) * rect.width -
            rect.height) /
          2;
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      },
    };

    if (fromURL) {
      if (options.galleryPIDs) {
        for (var j = 0; j < items.length; j++) {
          if (items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    if (isNaN(options.index)) {
      return;
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    //合并 调用者传入参数
    options = this._deepCopy(defaultoptions, options);

    var gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      items,
      options
    );
    gallery.init();

    // 查看原图
    if (options.enableOriImg && !isIE8) {
      if (document.querySelectorAll('.pswp__button--view--original').length == 0) {
        pswpElement
          .querySelectorAll('.pswp__top-bar .pswp__preloader')[0]
          .insertAdjacentHTML('beforebegin', '<button class="pswp__button pswp__button--view--original"></button>')
        $viewOriginImg = pswpElement.querySelectorAll('.pswp__button--view--original')[0];
      } else {
        var $viewOriginImg = pswpElement.querySelectorAll('.pswp__button--view--original')[0];
        $viewOriginImg && ($viewOriginImg.style.display = 'block');
      }
      $viewOriginImg.addEventListener(isTouch ? 'touchstart' : 'click', function (e) {
        e.stopPropagation ? e.stopPropagation() : (e.cancelBubble = true);
        var imgs = gallery.currItem.container && gallery.currItem.container.querySelectorAll('img');
        if (!Array.isArray(imgs)) return;
        for (var i = 0; i < imgs.length; i++) {
          if (imgs[i].className.indexOf('pswp__img--placeholder') === -1) {
            var bsrc = imgs[i] && imgs[i].getAttribute('bsrc');
            bsrc != 'null' && imgs[i] && imgs[i].setAttribute('src', bsrc);
          }
        }
      });
      $viewOriginImg.addEventListener('pswpTap', function (e) {
        e.stopPropagation();
      });
    } else {
      var $viewOriginImg = pswpElement.querySelectorAll('.pswp__button--view--original')[0];
      $viewOriginImg && ($viewOriginImg.style.display = 'none');
    }
  },

  /*大图node元素创建*/
  _addgallerydom: function () {
    var galleryv = document.getElementsByClassName('pswp')[0];
    if (!galleryv) {
      document.body.insertAdjacentHTML(
        'beforeend',
        '<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">\n' +
          '            <div class="pswp__bg"></div>\n' +
          '                <div class="pswp__scroll-wrap">\n' +
          '\n' +
          '            <div class="pswp__container">\n' +
          '                <div class="pswp__item"></div>\n' +
          '                <div class="pswp__item"></div>\n' +
          '                <div class="pswp__item"></div>\n' +
          '                </div>\n' +
          '\n' +
          '                <div class="pswp__ui pswp__ui--hidden">\n' +
          '\n' +
          '                <div class="pswp__top-bar">\n' +
          '\n' +
          '\n' +
          '            <div class="pswp__counter"></div>\n' +
          '\n' +
          '                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\n' +
          '\n' +
          '                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>\n' +
          '\n' +
          "                <button class=\"pswp__button pswp__button--view--original\"></button>\n" +
          "\n" +
          '                <div class="pswp__preloader">\n' +
          '                <div class="pswp__preloader__icn">\n' +
          '                <div class="pswp__preloader__cut">\n' +
          '                <div class="pswp__preloader__donut"></div>\n' +
          '                </div>\n' +
          '                </div>\n' +
          '                </div>\n' +
          '                </div>\n' +
          '\n' +
          '                <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\n' +
          '                <div class="pswp__share-tooltip"></div>\n' +
          '                </div>\n' +
          '\n' +
          '                <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">\n' +
          '                </button>\n' +
          '\n' +
          '                <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">\n' +
          '                </button>\n' +
          '\n' +
          '                <div class="pswp__caption">\n' +
          '                <div class="pswp__caption__center"></div>\n' +
          '                </div>\n' +
          '\n' +
          '                </div>\n' +
          '\n' +
          '                </div>\n' +
          '\n' +
          '                </div>'
      );
    }
  },
  /*---------- 组件自用函数实现对象深拷贝 ----------*/
  _deepCopy: function (p, c) {
    var that = this;
    var c = c || {};
    for (var i in p) {
      if (typeof p[i] === 'object') {
        c[i] =
          Object.prototype.toString.call(p[i]) === '[object Array]' ? [] : {};
        that._deepCopy(p[i], c[i]);
      } else {
        c[i] = p[i];
      }
    }
    return c;
  },
};

module.exports = hdfgallery;
